<template>
  <footer>
    <div class="contain">
      <div class="left">
        <img :src="config.LOGO_PNG" />
        <p v-if="!is_affiliate" >888-317-5531</p>
      </div>
      <div class="right">
        <div v-if="!is_affiliate" class="links">
          <a @click="goToSurvyio('/how-it-works')">How it works</a>
          <a @click="goToSurvyio('/features')">Features</a>
          <a @click="goToSurvyio('/pricing')">Plans & Pricing</a>
          <a class="action" @click="goTo('/register')">
            <span>Login</span> /
            <span>Signup</span>
          </a>
          <button @click="goToSurvyio('/contact')" class="btn text-btn">SCHEDULE DEMO</button>
        </div>
        <div v-else class="links">
          <a class="action" @click="goTo('/register')">
            <span>Login</span> /
            <span>Signup</span>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
import firebase from "firebase";

export default {
  async created() {
    await this.getAffiliates();
  }
};
</script>

<style lang="scss">
footer {
  background: white;
  border-top: 2px solid #eaeaea;
  padding: 20px 0;
  .contain {
    padding: 30px;
    text-align: center;
    display: flex;
    justify-content: space-between;
    @media screen and (max-width: 950px) {
      flex-direction: column;
    }
    .left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      p {
        margin-top: 20px;
      }
    }
    .right {
      @media screen and (max-width: 950px) {
        margin-top: 50px;
      }
      .links {
        display: flex;
        align-items: center;
        @media screen and (max-width: 950px) {
          flex-direction: column;
          align-items: flex-start;
        }
        .btn {
          margin-left: 30px;
          @media screen and (max-width: 950px) {
            margin-left: 0;
            margin-top: 30px;
          }
        }
        a {
          margin-left: 35px;
          font-weight: 600;
          cursor: pointer;
          &.action {
            color: #00bf6f;
          }
          @media screen and (max-width: 950px) {
            margin-left: 0;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  img {
    height: 55px;
  }
  p {
    color: black;
    margin: 0;
    text-align: center;
    &:first-child {
      font-size: 25px;
      font-weight: bold;
      margin-bottom: 10px;
      opacity: 0.3;
    }
  }
}
</style>
